import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const csmQueuesViewsConfigRoute: InvariantJiraRoute = {
	name: 'csm-queues-views-config',
	path: '/jira/customer-service-management/projects/:projectKey/queues/custom/:queueId/edit/:boardId',
	query: ['config?'],
	exact: true,
};
